// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { loadCustomerSalesPerson } from "@awc/App/Handlers/SalesPerson/LoadCustomerSalesPerson";
import { XNGAGE_ELEMENTS } from "@awc/XDL/constants";
import { xParserOptions } from "@awc/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    loadCustomerSalesPerson,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

export interface SalesRepInformationStyles {
    wrapper?: InjectableCss;
    title?: TypographyProps;
    image?: LazyImageProps;
}

export const salesRepInformationStyles: SalesRepInformationStyles = {};

const styles = salesRepInformationStyles;

const SalesRepInformation: React.FC<Props> = ({ loadCustomerSalesPerson }) => {
    const [salesperson, setSalesperson] = useState<any>({});
    const [salespersonProperties, setSalespersonProperties] = useState<any>({});

    useEffect(() => {
        loadCustomerSalesPerson({
            getSalesPersonPicks: false,
            onSuccess: (resultProps: any) => {
                if (resultProps.result) {
                    setSalesperson(resultProps.result.salesperson);
                    setSalespersonProperties(resultProps.result.properties);
                }
            },
        });
    }, []);

    if (!salesperson && !salespersonProperties.detailsContent) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.title}>{translate("Your Account Rep")}</Typography>
            {salesperson.imagePath && (
                <LazyImage {...styles.image} src={salesperson.imagePath} altText={salesperson.name} />
            )}
            <Typography>{salesperson.name}</Typography>
            <Typography>{salesperson.phone1}</Typography>
            <Typography>{salesperson.phone2}</Typography>
            <Typography>{salesperson.email}</Typography>
            {salespersonProperties.detailsContent && (
                <Typography>{parse(transformContentHtml(salespersonProperties.detailsContent), xParserOptions)}</Typography>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(SalesRepInformation),
    definition: {
        group: XNGAGE_ELEMENTS,
    },
};

export default widgetModule;
